import {
  BasicField,
  OwnershipTransferFieldsParams
} from "./ownership-transfer-fields.interface";

import { AccountType } from "@/modules/Accounts/types";

export const ownershipTransferFields = ({
  values,
  accountType,
  documentNumber
}: OwnershipTransferFieldsParams) => {
  const assigneeInfoFields: BasicField[] = [
    {
      label: "Nome / Razão social",
      placeholder: "Nome do cedente",
      type: "text",
      name: "fullName",
      required: true,
      value: values?.fullName || ""
    },
    {
      label: "RG / Inscrição Estadual",
      type: "text",
      name: "secondaryDocument",
      required: false,
      value: values?.secondaryDocument || ""
    }
  ];

  if (accountType === AccountType.LEGAL) {
    assigneeInfoFields.push(
      {
        label: "CNPJ",
        type: "text",
        name: "documentNumber",
        required: true,
        value: documentNumber || values?.documentNumber || "",
        mask: "**.***.***/****-**"
      },
      {
        label: "Nome do Representante Legal",
        type: "text",
        name: "legalRepresentativeName",
        required: true,
        value: values?.legalRepresentativeName || ""
      },
      {
        label: "CPF do Representante Legal",
        type: "text",
        name: "legalRepresentativeDocument",
        required: true,
        value: values?.legalRepresentativeDocument || "",
        mask: "999.999.999-99"
      }
    );
  }

  if (accountType === AccountType.PHYSICAL) {
    assigneeInfoFields.push({
      label: "CPF",
      type: "text",
      name: "documentNumber",
      required: true,
      value: documentNumber || values?.documentNumber || "",
      mask: "999.999.999-99"
    });
  }

  const fields = [
    {
      name: "groupedFields",
      key: "nameGroupedFields",
      fields: [
        {
          type: "basicFields",
          name: "assigneeInfos",
          description: "Dados do Cedente",
          fields: assigneeInfoFields
        }
      ]
    },
    {
      name: "groupedFields",
      key: "contactGroupedFields",
      fields: [
        {
          type: "basicFields",
          name: "assigneeInfos",
          description: "Contato do Cedente",
          fields: [
            {
              label: "WhatsApp",
              placeholder: "Whatsapp",
              type: "text",
              name: "whatsapp",
              value: values?.whatsapp || "",
              required: true,
              mask: "(99) 99999-9999"
            },
            {
              label: "Email",
              placeholder: "Email",
              type: "text",
              name: "email",
              value: values?.email || "",
              required: true
            }
          ]
        }
      ]
    },
    {
      name: "groupedFields",
      key: "addressesGroupedFields",
      fields: [
        {
          label: "Endereço do Cedente",
          type: "addresses",
          name: "addresses",
          newFieldButtonMessage: "Adicionar novo endereço",
          value: [
            {
              zipCode: values?.zipCode || "",
              value: values?.city || "",
              state: values?.uf || "",
              street: values?.street || "",
              neighborhood: values?.neighborhood || "",
              number: values?.number || "",
              note: values?.note || ""
            }
          ],
          fields: [
            {
              label: "Código postal",
              type: "zipCode",
              name: "zipCode",
              mask: "99999-999",
              value: "",
              key: "zipCode",
              required: true
            },
            {
              label: "Cidade",
              type: "text",
              name: "city",
              key: "city",
              value: "",
              required: true,
              disabled: true
            },
            {
              label: "Estado",
              type: "text",
              name: "state",
              key: "state",
              value: "",
              mask: "**",
              required: true,
              disabled: true
            },
            {
              label: "Rua",
              type: "text",
              name: "street",
              key: "street",
              disabled: true,
              value: ""
            },
            {
              label: "Bairro",
              type: "text",
              name: "neighborhood",
              key: "neighborhood",
              disabled: true,
              value: ""
            },
            {
              label: "Número",
              type: "string",
              name: "number",
              key: "number",
              value: "",
              required: true
            },
            {
              label: "Complemento",
              type: "text",
              name: "note",
              key: "note",
              value: "",
              required: false,
              disabled: false
            }
          ]
        }
      ]
    }
  ];

  return fields;
};
